import { H2 } from "@datapay-by-datacom/design-system";

export function SankeyScreen() {
  return (
    <div>
      <H2>Variance Cascade (Sankey)</H2>
      <p>Sankey diagram - coming soon.</p>
    </div>
  );
}
